import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { MODALS } from 'global-constants';

import logout from 'shared/utils/logout';

import Button from 'shared/components/Button';
import NavLinks from 'shared/components/Navigation/NavLinks';
import GlobalSearchInput from 'shared/components/GlobalSearchInput';
import Link from 'shared/components/Navigation/MobileNav/IconLink';
import { MOBILE_NAV_CONTENT } from 'shared/components/Navigation/MobileNav/constants';

import { openModal } from 'shared/components/Modals/reducer';

import WithUser from 'shared/HOCs/WithUser';

import UserBox from './UserBox';
import logout_image from 'assets/images/profile/logout.svg';

import styles from './styles.module.scss';

class DefaultNavContent extends React.Component {
  openSignUp = () => {
    this.props.openModal({
      modalName: MODALS.SIGNUP
    });
  };

  openSignIn = () => {
    this.props.openModal({
      modalName: MODALS.LOGIN
    });
  };

  render() {
    const { notificationAlertCount } = this.props;

    return (
      <React.Fragment>
        {!_.isEmpty(this.props.user) && (
          <UserBox
            user={this.props.user}
            notificationAlertCount={notificationAlertCount}
            openAction={() => this.props.openAction(MOBILE_NAV_CONTENT.PROFILE)}
          />
        )}

        <div className={styles.search}>
          <GlobalSearchInput
            mobile={true}
            submitAction={this.props.redirectToGlobalSearchOrSubmit}
            isNav={true}
            shouldAutoFocus={false}
          />
        </div>

        <NavLinks
          openAction={this.props.openAction}
          closeNavigation={this.props.closeNavigation}
        />
        <div className={styles.bottom}>
          {!_.isEmpty(this.props.user) ? (
            <Link
              alt="logout icon"
              img={logout_image}
              onClick={logout}
              className={styles.logout}>
              Logout
            </Link>
          ) : (
            <React.Fragment>
              <Button
                color="dark"
                className={styles.signupButton}
                onClick={this.openSignUp}>
                Sign up for free
              </Button>
              <Button
                color="primary"
                className={styles.signinButton}
                onClick={this.openSignIn}>
                Sign In
              </Button>
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default WithUser(
  connect(
    null,
    { openModal }
  )(DefaultNavContent)
);
